import React from "react";

class NounProjectContainer extends React.Component {
    render() {
        return <div>{this.props.children}</div>;
    }
}

export default NounProjectContainer;
